import { FC, PropsWithChildren } from 'react';

import { Template } from '@/template';

import { appService } from '@/styles/templates/layout.module.scss';

const TemplateService: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className={appService}>
      <Template>{children}</Template>
    </div>
  );
};
export default TemplateService;
